<template >
  <el-dialog
    :title="'岗点人员'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-row>
      <el-col :span="24">
        <el-select clearable :disabled="deptdisable" @change="selectChanged2"   filterable   v-model="form.dept"  placeholder="请选择大队">
          <el-option
                  v-for="item in depts"
                  :key="item.bmid"
                  :label="item.bmmc"
                  :value="item.bmid"
                  :disabled="deptdisable">
          </el-option>
        </el-select>
        <el-select clearable :disabled="childdeptdisable" v-model="form.childDept" @change="selectChanged3"  placeholder="请选择班组" clearable>
          <el-option
                  v-for="item in childDept"
                  :key="item.bmid"
                  :label="item.bmmc"
                  :value="item.bmid"
          >
          </el-option>
        </el-select>
        <el-input @change="selectChanged3"  @keyup.enter.native="selectChanged3" placeholder="模糊查询用户名" v-model="form.name" prefix-icon="el-icon-user" clearable style="width: 20%">
        </el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-table   :data="userList" ref="userTable" v-loading="loading" style="text-align: center; width: 100%;" :row-key="getRowKeys" @selection-change="selectionChangeHandle" @row-click="handleRowClick">
        <el-table-column
                type="selection"
                header-align="center"
                align="center"
                width="50"
                :reserve-selection="true"
                :selectable="canSelection"
        >
          <!--                -->
        </el-table-column>
        <el-table-column prop="username" label="用户编号">

        </el-table-column>
        <el-table-column prop="xm" label="用户名">
        </el-table-column>
        <el-table-column label="手机号码" prop="sjhm">
        </el-table-column>
        <el-table-column label="部门">
          <template slot-scope="scope">
            <span>{{getBm(scope.row)}}</span>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination :current-page.sync="currentPage" background layout="total, prev, pager, next" :total="total" @current-change="pageUser" style="margin-top: 1rem;"></el-pagination>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
<el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>


  export default {
    data () {
      return {
        visible: false,
        pageIndex: 1,
        pageSize:10,
        totalPage: 0,
        currentPage: 1,
        id: 0,
        dataList:[],
        total:0,
        dataListSelections:[],
        depts:[],
        loading:false,
        useridList:[],
        userList:[],
        childDept:[],
        deptdisable:false,
        childdeptdisable:false,
        form:{
          dept:'',
          childDept: '',
          name:''
        },
        bmxx:[],
        otherIds:[]
      }
    },
    created () {

    },
    methods: {
      init (id) {
        this.id =id
        this.dataList=[]
        this.pageIndex=1;
        this.totalPage=0;
        this.userList=[]
        this.useridList=[]
        this.dataListSelections=[]
        this.form.dept=''
        this.form.childDept=''
        this.form.name=''
        this.$request.get('/bjba/map/userIdsList/'+this.id,{
          params:{
            isTemp:0
          }
        }).then(res=> {
          this.useridList = res.data.data
          this.visible = true
          this.$nextTick(() => {
            this.$refs.userTable.clearSelection()
            this.getDepts()
            this.getbmxx()
          })
        })
        this.getOtherUser()
      },
      getDepts() {
        let that = this;
        this.$request.get('/bjba/kqtj/getFirstMentForUser',{
          params: {
            userid:this.$store.getters.username
          }

        }).then(res => {
          that.depts = res.data
          if(this.depts && this.depts[0]) {
            var zzdyqc = this.$store.getters.user.zzdyqc;
            if(zzdyqc != this.CONST_ZN_BM) {
              var zw = this.$store.getters.user.zw;

              if(zw) {
                if(zw=='01'||zw=='02'||zw=='03') {
                  this.form.dept = that.depts[0].bmid
                  this.deptdisable = true
                  if(zw !='01') {
                    this.childdeptdisable =true;
                  }
                  this.selectChanged2(this.form.dept)
                }
                this.selectChanged2(this.form.dept)
              } else {this.selectChanged2(this.form.dept)}

            } else {  this.selectChanged2(this.form.dept)}
          }
        })
      },
      selectChanged2(value) {
        this.currentPage = 1
        this.childDept = []
        this.form.childDept =''
        this.$request({
          method: 'get',
          url: '/bjba/kqtj/getMentForUser2',
          params: {
            fbmid: value,
            userid:this.$store.getters.username
          }
        }).then((response) => {

          this.childDept = response.data;
          var zzdyqc = this.$store.getters.user.zzdyqc;
          if(zzdyqc != this.CONST_ZN_BM) {
            var zw = this.$store.getters.user.zw;
            if(zw) {
              if(zw=='02'||zw=='03') {
                if(this.childDept[0]) {
                  this.form.childDept = this.childDept[0].bmid

                }
              }
            }
          }
          this.getUserList();
        }).catch((err) => {
          console.log(err)
        })
      },
      selectChanged3(value) {
        this.currentPage = 1;
        this.getUserList();


      },
      canSelection(row, rowIndex) {
    if (this.otherIds.some(item => item === row.id)) {
      return false
    } else {
      return true// 不禁用
    }
  },
      getbmxx() {
        let that = this;
        this.$request.get('/bjba/yhgl/getbmxx').then(res => {
          console.log("bmxx:", res);
          that.bmxx = res.data;
        })
      },
      getBm(user) {
        var ubmid ;
        if(user.ddbz)  ubmid= user.ddbz;
        else ubmid = user.zzdyqc
        for(var i=0; i<this.bmxx.length;i++) {

          if(this.bmxx[i].bmid == ubmid) {
            return this.bmxx[i].bmmc
          }
        }
      },
      getRowKeys(row) {
        return row.id;
      },
      selectionChangeHandle (val) {
        console.log(val)
        this.dataListSelections = val
        if(val && val.length>0) {
          for(var i=0;i<val.length;i++) {
            var j =this.useridList.indexOf(val[i].id);
            if(j !== -1) {
              this.useridList.splice(j,1);
            }
          }
        }
      },
      handleRowClick(row, column, event){
        if (this.otherIds.some(item => item === row.id)) {
          return false
        } else {
          this.$refs.userTable.toggleRowSelection(row);
        }
      },
      getUserList: function () {
        this.loading = true
        this.form.page = this.currentPage;
        this.form.pagesize = 10
        this.form.userid = this.$store.getters.username
        this.$request.get('/bjba/yhgl/getUserList', {
          params: this.form
        }).then(res => {
          const {
            data
          } = res
          console.log("列表数据：", data)
          this.userList = data.data
          this.total = data.total
          setTimeout(() => {
            this.setSelection()
          }, 50)

          console.log(this.userList);
          //this.total = data.totalElements
          this.loading = false
        }).catch(err => {
          this.$message({
            message: '获取用户列表出现异常!',
            type: 'error',
            center: true,
            showClose: true
          })
          this.loading = false
          console.log(err)
        })
      },
      getOtherUser() {
        this.$request.get('/bjba/map/userIdsList/'+this.id,{
          params:{
            isTemp: 1
          }
        }).then(res=> {
          this.otherIds = res.data.data
        })
      },
      // 切换页码
      pageUser(page) {
        this.currentPage = page
        this.getUserList()
      },
      setSelection() {

        if (!this.useridList || this.useridList.length <= 0) {
          return
        }


        for (let i = 0; i < this.userList.length; i++) {
          if (this.useridList.indexOf(this.userList[i]['id']) >= 0) {
            this.$refs.userTable.toggleRowSelection(this.userList[i], true)
          }
        }

      },
      selectionChange(selection) {
        console.log(selection)
      },
      dataFormSubmit() {
      var data = {gdid:'',userids:[]}
      data.gdid = this.id
      data.userids =this.dataListSelections.map(item => {
        return item.id
      });
      if(this.useridList && this.useridList.length>0) {
        data.userids = data.userids.concat(this.useridList)
      }
            this.$http({
              url: `/bjba/map/setUserGd`,
              method: 'post',
              data: data
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
                this.visible = false
                this.$emit('refreshDataList')
              }else if(data && data.code === 500) {
                this.$message({
                  message: data.message,
                  type: "error",
                  duration: 1500
                })
              }
            })

      }
    }
  }
</script>

<style lang="scss" >
  #left .el-form-item__content{
    text-align: left;
  }
  .menu-list__input,
  .icon-list__input {

    > .el-input__inner {
      cursor: pointer;
    }

  }

  .mod-menu__icon-popover {
    max-width: 350px;
  }

  .mod-menu__icon-list {
    max-height: 380px;
    padding: 0;
    margin: -8px 0 0 -8px;

    > .el-button {
      padding: 8px;
      margin: 8px 0 0 8px;

      > span {
        display: inline-block;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        font-size: 18px;
      }

    }
  }

  .icon-list__tips {
    font-size: 18px;
    text-align: center;
    color: #e6a23c;
    cursor: pointer;
  }
</style>
